<template>
	<div
		v-if="repo"
		class="resource-card__source sgnl-text-color-secondary"
	>
		<span class="source-segment">
			<GitRepo16 />
			<a
				class="card-link sgnl-text-color-secondary"
				:href="repo.RemoteURL"
				target="_blank"
				rel="noopener noreferrer"
			>
				{{ repoFullNameFromUrl(repo.RemoteURL) }}
			</a>
		</span>
		<v-divider
			vertical
			class="source-divider"
		/>
		<span class="source-segment">
			<Branch16 />
			{{ repo.Branch }}
			<Commit16 />
			{{ repo.Commit.slice(0, 8) }}
		</span>
		<template v-if="showBuildDirectory">
			<v-divider
				vertical
				class="source-divider"
			/>
			<span class="source-segment">
				<FolderShared16 />
				./{{ repo.BuildDirectory }}
			</span>
		</template>
	</div>
	<div
		v-else-if="sourceCode"
		class="resource-card__source sgnl-text-color-secondary"
	>
		<span class="source-segment">
			<Code16 />
			Code Playground
		</span>
		<v-divider
			vertical
			class="source-divider"
		/>
		<span>{{ lineCount }} lines</span>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import GitRepo16 from "@carbon/icons-vue/es/git--repo/16";
import Code16 from "@carbon/icons-vue/es/code/16";
import Branch16 from "@carbon/icons-vue/es/branch/16";
import Commit16 from "@carbon/icons-vue/es/commit/16";
import FolderShared16 from "@carbon/icons-vue/es/folder--shared/16";

import { repoFullNameFromUrl } from "@/js/utilities";
import { Repository } from "@/types/api/repositories";
import { SourceCode } from "@/types/api/sourceCode";

export default defineComponent({
	name: "SourceReference",
	components: { GitRepo16, Code16, Branch16, Commit16, FolderShared16 },
	props: {
		repo: { type: Object as PropType<Repository | null>, default: null },
		sourceCode: { type: Object as PropType<SourceCode | null>, default: null },
		showBuildDirectory: { type: Boolean, default: false },
	},
	computed: {
		lineCount(): number {
			const code = this.sourceCode?.Code;
			if (!code) return 0;
			return (code.match(/\n/g) || []).length + 1;
		},
	},
	methods: { repoFullNameFromUrl },
});
</script>

<style lang="scss" scoped>
.resource-card__source {
	font-size: var(--sgnl-font-size-paragraph-s);
}

.resource-card__source :deep(svg) {
	color: var(--sgnl-default-secondary-icon);
}

.card-link {
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
}

.source-segment {
	display: inline-flex;
	align-items: center;
	gap: var(--sgnl-space-4);
}

.source-divider {
	height: var(--sgnl-unit-16);
	align-self: center;
	border-color: var(--sgnl-default-primary-border);
}
</style>
